module.exports = __webpack_public_path__ + "static/media/terms_and_conditions_fr.04617ac6.pdf";